<template>
  <div class="wrapper">
    <!-- 上传区域 -->
    <el-card class="upload-card" style="margin-bottom: 20px">
      <div style="display: flex; align-items: flex-start; gap: 30px">
        <!-- 左侧上传区域 -->
        <div class="upload-wrap-compact">
          <el-upload
              class="upload-demo"
              drag
              action="#"
              accept=".xlsx"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :limit="1"
              :auto-upload='false'
              :on-change="handleChange"
              :on-exceed="handleExceed"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">拖拽或<em style="color: #409EFF">点击上传</em></div>
            <div class="el-upload__tip" slot="tip" style="line-height: 1.5">
              表头格式：发件邮箱、订单号、客户邮箱、问题描述/通用字段1、类型、产品名称/通用字段2、<br/>产品链接/通用字段3、通用主题、通用字段4、通用字段5、通用字段6
            </div>
          </el-upload>
          <el-button 
              type="success" 
              size="small" 
              icon="el-icon-download"
              @click="downloadTemplate"
              style="width: 100%; margin-top: 10px">
            下载模板
          </el-button>
        </div>

        <!-- 右侧统计信息 -->
        <div class="statistics-wrap" v-if="uploadStatistics.show">
          <h3 style="margin-top: 0; margin-bottom: 15px; color: #303133">
            <i class="el-icon-data-analysis" style="margin-right: 5px"></i>导入统计
          </h3>
          <el-row :gutter="15">
            <el-col :span="8">
              <div class="stat-card stat-success">
                <div class="stat-value">{{ uploadStatistics.success }}</div>
                <div class="stat-label">成功</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-card stat-skipped">
                <div class="stat-value">{{ uploadStatistics.skipped }}</div>
                <div class="stat-label">跳过</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-card stat-failed">
                <div class="stat-value">{{ uploadStatistics.failed }}</div>
                <div class="stat-label">失败</div>
              </div>
            </el-col>
          </el-row>
          <div style="margin-top: 15px; padding: 10px; background: #f0f9ff; border-radius: 4px; font-size: 13px; color: #606266">
            <i class="el-icon-info" style="color: #409EFF"></i>
            总共处理 <strong>{{ uploadStatistics.total }}</strong> 行数据
          </div>
          
          <!-- 详细信息列表 -->
          <div v-if="uploadStatistics.details && uploadStatistics.details.length > 0" style="margin-top: 15px">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px">
              <h4 style="margin: 0; color: #606266; font-size: 14px">
                <i class="el-icon-document" style="margin-right: 5px"></i>处理详情
              </h4>
              <el-button type="text" size="small" @click="showDetailsDialog = true">
                查看全部 ({{ uploadStatistics.details.length }})
              </el-button>
            </div>
            <div class="details-preview">
              <div v-for="(detail, index) in uploadStatistics.details.slice(0, 3)" 
                   :key="index" 
                   class="detail-item">
                <i class="el-icon-warning" style="color: #E6A23C; margin-right: 5px"></i>
                {{ detail }}
              </div>
              <div v-if="uploadStatistics.details.length > 3" class="detail-more">
                还有 {{ uploadStatistics.details.length - 3 }} 条信息...
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 详细信息对话框 -->
    <el-dialog
        title="处理详情"
        :visible.sync="showDetailsDialog"
        width="700px"
        top="5vh">
      <div style="max-height: 60vh; overflow-y: auto">
        <el-timeline>
          <el-timeline-item 
              v-for="(detail, index) in uploadStatistics.details" 
              :key="index"
              :timestamp="'第 ' + (index + 1) + ' 条'"
              placement="top">
            <div style="font-size: 14px; color: #606266">{{ detail }}</div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDetailsDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 邮件记录列表 -->
    <el-card class="record-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bold; font-size: 16px">邮件发送记录</span>
      </div>

      <!-- 搜索筛选栏 -->
      <div class="filter-bar" style="margin-bottom: 20px">
        <el-form :inline="true" :model="filters" class="demo-form-inline">
          <el-form-item label="状态">
            <el-select v-model="filters.status" placeholder="全部状态" clearable style="width: 120px">
              <el-option label="全部" value=""></el-option>
              <el-option label="待发送" value="0"></el-option>
              <el-option label="已发送" value="1"></el-option>
              <el-option label="发送失败" value="2"></el-option>
              <el-option label="处理中" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发件邮箱">
            <el-input v-model="filters.sender_email" placeholder="输入发件邮箱" clearable style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input 
              v-model="filters.order_no" 
              type="textarea" 
              :rows="1"
              placeholder="输入订单号（支持多个，逗号或换行分隔）,或从表格复制粘贴" 
              clearable 
              style="width: 250px">
            </el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="filters.type" placeholder="全部类型" clearable style="width: 120px">
              <el-option label="全部" value=""></el-option>
              <el-option label="地址" value="CONFIRM_ADDRESS"></el-option>
              <el-option label="定制" value="CONFIRM_CUSTOMIZATION"></el-option>
              <el-option label="通用" value="GENERAL_REPLY"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
            <el-button @click="resetFilters" icon="el-icon-refresh-left">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 批量操作 -->
      <div style="margin-bottom: 15px">
        <el-button 
          type="warning" 
          size="small" 
          @click="handleBatchResend" 
          :disabled="selectedRows.length === 0"
          icon="el-icon-refresh">
          批量重发 ({{ selectedRows.length }})
        </el-button>
        <el-button 
          type="danger" 
          size="small" 
          @click="handleBatchDelete" 
          :disabled="selectedRows.length === 0"
          icon="el-icon-delete">
          批量删除 ({{ selectedRows.length }})
        </el-button>
        <span style="margin-left: 10px; color: #909399; font-size: 12px">
          * 仅已发送和发送失败的记录可操作
        </span>
      </div>

      <!-- 表格 -->
      <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName">
        <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable">
        </el-table-column>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="info" size="small">待发送</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success" size="small">已发送</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="danger" size="small">发送失败</el-tag>
            <el-tag v-else-if="scope.row.status === 3" type="warning" size="small">处理中</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sender_email" label="发件邮箱" width="180"></el-table-column>
        <el-table-column prop="order_no" label="订单号" width="120"></el-table-column>
        <el-table-column prop="customer_email" label="客户邮箱" width="180"></el-table-column>
        <el-table-column prop="issue_description" label="问题描述/通用字段1" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="send_count" label="发送次数" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.send_count > 1" type="warning" size="small">
              {{ scope.row.send_count }} 次
            </el-tag>
            <span v-else>{{ scope.row.send_count }} 次</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'CONFIRM_ADDRESS'" type="primary" size="small">地址</el-tag>
            <el-tag v-else-if="scope.row.type === 'CONFIRM_CUSTOMIZATION'" type="info" size="small">定制</el-tag>
            <el-tag v-else-if="scope.row.type === 'GENERAL_REPLY'" type="success" size="small">通用</el-tag>
            <el-tag v-else type="info" size="small">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="product_name" label="产品名称/通用字段2" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="product_link" label="产品链接/通用字段3" width="250" show-overflow-tooltip>
          <template slot-scope="scope">
            <a v-if="scope.row.product_link" :href="scope.row.product_link" target="_blank" style="color: #409EFF">
              {{ scope.row.product_link }}
            </a>
            <span v-else style="color: #909399">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="general_subject" label="通用主题" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="general_field4" label="通用字段4" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="general_field5" label="通用字段5" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="general_field6" label="通用字段6" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="error_message" label="错误信息" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.error_message" style="color: #F56C6C">{{ scope.row.error_message }}</span>
            <span v-else style="color: #909399">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="sent_at" label="发送时间" width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.sent_at" style="line-height: 1.5">
              <div>{{ $moment(scope.row.sent_at).format("YYYY-MM-DD") }}</div>
              <div>{{ $moment(scope.row.sent_at).format("HH:mm:ss") }}</div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.created_at" style="line-height: 1.5">
              <div>{{ $moment(scope.row.created_at).format("YYYY-MM-DD") }}</div>
              <div>{{ $moment(scope.row.created_at).format("HH:mm:ss") }}</div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
                v-if="scope.row.status === 1 || scope.row.status === 2"
                type="text"
                size="small"
                @click="handleResend(scope.row)"
                icon="el-icon-refresh">
              重发
            </el-button>
            <span v-else-if="scope.row.status === 0" style="color: #909399; font-size: 12px">待发送</span>
            <span v-else-if="scope.row.status === 3" style="color: #909399; font-size: 12px">处理中</span>
            <span v-else style="color: #67C23A; font-size: 12px">已完成</span>
            
            <el-divider direction="vertical" v-if="scope.row.status !== 0 && scope.row.status !== 3"></el-divider>
            
            <el-button
                v-if="scope.row.status !== 0 && scope.row.status !== 3"
                type="text"
                size="small"
                @click="handleDelete(scope.row)"
                style="color: #F56C6C"
                icon="el-icon-delete">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          style="margin-top: 20px; text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-card>

    <!-- 错误行号对话框 -->
    <el-dialog
        title="上传失败"
        :visible.sync="errorDialogVisible"
        width="500px">
      <div style="line-height: 1.8">
        <p style="color: #F56C6C; font-weight: bold">以下行的发件邮箱不存在于系统中：</p>
        <p style="margin-top: 10px">{{ errorMessage }}</p>
        <p style="margin-top: 10px; color: #909399; font-size: 14px">请检查并修改后重新上传。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="errorDialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {uploadImage} from "../../utils/fileUpload";
import ExcelJS from 'exceljs';

export default {
  name: "BatchTemplate",
  data() {
    return {
      // 上传相关
      fileList: [],
      errorDialogVisible: false,
      errorMessage: '',
      
      // 上传统计
      uploadStatistics: {
        show: false,
        total: 0,
        success: 0,
        skipped: 0,
        failed: 0,
        details: []
      },
      
      // 详情对话框
      showDetailsDialog: false,

      // 列表相关
      tableData: [],
      total: 0,
      page: 1,
      limit: 20,
      loading: false,

      // 筛选条件
      filters: {
        status: '',
        sender_email: '',
        order_no: '',
        type: ''
      },

      // 批量选择
      selectedRows: [],

      // 自动刷新
      refreshTimer: null
    };
  },
  
  mounted() {
    this.loadRecords();
    this.startAutoRefresh();
  },
  
  beforeDestroy() {
    this.stopAutoRefresh();
  },

  methods: {
    // 上传处理
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    
    handlePreview(file) {
      console.log(file);
    },
    
    handleExceed() {
      this.$message.error('最多只能上传10个表格');
    },

    // 下载模板
    async downloadTemplate() {
      try {
        // 创建工作簿
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('批量邮件');
        
        // 定义表头
        const headers = ['发件邮箱', '订单号', '客户邮箱', '问题描述/通用字段1', '类型', '产品名称/通用字段2', '产品链接/通用字段3','通用主题','通用字段4','通用字段5','通用字段6'];
        
        // 设置表头行
        const headerRow = worksheet.addRow(headers);
        
        // 设置表头样式（居中、加粗）
        headerRow.font = { bold: true };
        headerRow.alignment = { 
          horizontal: 'center', 
          vertical: 'middle' 
        };
        headerRow.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE0E0E0' } // 浅灰色背景
        };
        
        // 设置列宽
        worksheet.columns = [
          { width: 25 }, // 发件邮箱
          { width: 15 }, // 订单号
          { width: 25 }, // 客户邮箱
          { width: 30 }, // 问题描述
          { width: 20 }, // 类型
          { width: 25 }, // 产品名称
          { width: 40 }, // 产品链接
          { width: 25 }, // 通用主题
          { width: 25 }, // 通用字段4
          { width: 25 }, // 通用字段5
          { width: 25 }, // 通用字段6
        ];
        
        // 添加示例数据
        worksheet.addRow(['service@example.com', '#1001', 'customer@example.com', 'Address incomplete', '地址']);
        worksheet.addRow(['support@shop.com', '#1002', 'user@test.com', 'Wrong zip code', '定制', 'Custom T-Shirt', 'https://example.com/product/123']);
        worksheet.addRow(['support@shop.com', '#1003', 'user@test.com', 'General Field 1', '通用', 'General Field 2', 'General Field 3','General Subject','General Field 4','General Field 5','General Field 6']);
        
        // 为E列（类型列，第5列）添加数据验证（下拉列表）
        // 允许选择"地址"、"定制"、"通用"或留空
        // 设置从第2行开始到第1000行的数据验证（足够大的范围）
        const typeColumnIndex = 5; // E列是第5列
        for (let row = 2; row <= 1000; row++) {
          const cell = worksheet.getCell(row, typeColumnIndex);
          cell.dataValidation = {
            type: 'list',
            allowBlank: true, // 允许空白
            formulae: ['"地址,定制,通用"'], // 下拉选项，用逗号分隔
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '输入错误',
            error: '只能选择"地址"、"定制"、"通用"，或留空'
          };
        }
        
        // 生成Excel文件
        const buffer = await workbook.xlsx.writeBuffer();
        
        // 创建Blob并下载
        const blob = new Blob([buffer], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '批量确认信息邮件模板.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
        
        this.$message.success('模板下载成功');
      } catch (error) {
        console.error('下载模板失败:', error);
        this.$message.error('模板下载失败，请重试');
      }
    },

    handleChange(file) {
      let fd = new FormData();
      fd.append('file', file.raw);
      
      uploadImage(this.api.email_excel_upload, fd).then(res => {
        var data = res.data;
        if (data.code === 200) {
          // 显示统计信息
          const result = data.data;
          this.uploadStatistics = {
            show: true,
            total: result.total_rows || 0,
            success: result.new_records || 0,
            skipped: result.skipped_rows || 0,
            failed: result.failed_rows || 0,
            details: result.details || []
          };
          
          this.$message.success(data.msg || '上传成功');
          
          // 清空文件列表
          this.fileList = [];
          
          // 刷新列表
          setTimeout(() => {
            this.loadRecords();
          }, 500);
        } else {
          // 即使失败也显示统计信息（如果有详细数据）
          if (data.data && data.data.details && data.data.details.length > 0) {
            const result = data.data;
            this.uploadStatistics = {
              show: true,
              total: result.total_rows || 0,
              success: result.new_records || 0,
              skipped: result.skipped_rows || 0,
              failed: result.failed_rows || 0,
              details: result.details || []
            };
            this.$message.error(data.msg || '上传失败');
          } else {
            // 没有详细数据时显示简单的错误对话框
            this.uploadStatistics.show = false;
            this.uploadStatistics.details = [];
            this.errorMessage = data.msg || '上传失败';
            this.errorDialogVisible = true;
          }
          
          // 清空文件列表
          this.fileList = [];
        }
      }).catch(error => {
        console.log(error);
        this.$message.error('上传失败');
        this.uploadStatistics.show = false;
        this.uploadStatistics.details = [];
        // 清空文件列表
        this.fileList = [];
      });
    },

    // 加载列表
    loadRecords() {
      this.loading = true;
      const params = {
        page: this.page,
        limit: this.limit,
      };
      
      if (this.filters.status !== '') {
        params.status = this.filters.status;
      }
      if (this.filters.sender_email) {
        params.sender_email = this.filters.sender_email;
      }
      if (this.filters.order_no) {
        params.order_no = this.filters.order_no;
      }
      if (this.filters.type) {
        params.type = this.filters.type;
      }

      this.http.fetchGet(this.api.batch_email_list, params).then(res => {
        this.loading = false;
        if (res.data.code === 200) {
          const result = res.data.data;
          this.tableData = result.data || [];
          this.total = result.total || 0;
          this.page = result.current_page || 1;
        } else {
          this.$message.error('加载数据失败：' + res.data.msg);
        }
      }).catch(error => {
        this.loading = false;
        console.log(error);
        this.$message.error('加载数据失败');
      });
    },

    // 搜索
    handleSearch() {
      this.page = 1;
      this.loadRecords();
    },

    // 重置筛选
    resetFilters() {
      this.filters = {
        status: '',
        sender_email: '',
        order_no: '',
        type: ''
      };
      this.page = 1;
      this.loadRecords();
    },

    // 分页
    handleSizeChange(val) {
      this.limit = val;
      this.loadRecords();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.loadRecords();
    },

    // 批量选择
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    // 检查是否可选择（仅失败的记录可选）
    checkSelectable(row) {
      return row.status === 1||row.status === 2;
    },

    // 表格行样式
    tableRowClassName({row}) {
      if (row.status === 2) {
        return 'error-row';
      }
      return '';
    },

    // 单个重发
    handleResend(row) {
      this.$confirm('确定要重发这条邮件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.resendEmails([row.id]);
      }).catch(() => {});
    },

    // 批量重发
    handleBatchResend() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要重发的记录');
        return;
      }

      // 检查是否全部为失败状态
      const nonFailedRows = this.selectedRows.filter(row => row.status !== 2&&row.status !== 1);
      if (nonFailedRows.length > 0) {
        this.$message.warning('只能重发失败的和已发送的邮件记录');
        return;
      }

      const ids = this.selectedRows.map(row => row.id);
      this.$confirm(`确定要重发 ${ids.length} 条邮件记录吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.resendEmails(ids);
      }).catch(() => {});
    },

    // 执行重发
    resendEmails(ids) {
      const loading = this.$loading({
        lock: true,
        text: '正在加入重发队列...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.http.fetchPost(this.api.batch_email_resend, {ids}).then(res => {
        loading.close();
        if (res.data.code === 200) {
          const result = res.data.data;
          if (result.failed_ids && result.failed_ids.length > 0) {
            this.$message.warning(`已加入重发队列 ${result.success_count} 条，失败 ${result.failed_ids.length} 条`);
          } else {
            this.$message.success(`已加入重发队列 ${result.success_count} 条`);
          }
          // 刷新列表
          this.loadRecords();
        } else {
          this.$message.error('重发失败：' + res.data.msg);
        }
      }).catch(error => {
        loading.close();
        console.log(error);
        this.$message.error('重发失败');
      });
    },

    // 删除记录
    handleDelete(row) {
      this.$confirm('确定要删除这条记录吗？删除后无法恢复。', '警告', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在删除...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        this.http.fetchDel(this.api.batch_email_delete + '/' + row.id).then(res => {
          loading.close();
          if (res.data.code === 200) {
            this.$message.success('删除成功');
            // 刷新列表
            this.loadRecords();
          } else {
            this.$message.error('删除失败：' + res.data.msg);
          }
        }).catch(error => {
          loading.close();
          console.log(error);
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },

    // 批量删除
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要删除的记录');
        return;
      }

      // 检查是否全部为已发送或发送失败状态
      const invalidRows = this.selectedRows.filter(row => row.status !== 1 && row.status !== 2);
      if (invalidRows.length > 0) {
        this.$message.warning('只能删除已发送或发送失败的邮件记录');
        return;
      }

      const ids = this.selectedRows.map(row => row.id);
      this.$confirm(`确定要删除 ${ids.length} 条记录吗？删除后无法恢复。`, '警告', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteEmails(ids);
      }).catch(() => {});
    },

    // 执行批量删除
    deleteEmails(ids) {
      const loading = this.$loading({
        lock: true,
        text: '正在删除...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.http.fetchPost(this.api.batch_email_batch_delete, {ids}).then(res => {
        loading.close();
        if (res.data.code === 200) {
          const result = res.data.data;
          if (result.failed_ids && result.failed_ids.length > 0) {
            this.$message.warning(`删除成功 ${result.success_count} 条，失败 ${result.failed_ids.length} 条`);
          } else {
            this.$message.success(`删除成功 ${result.success_count} 条`);
          }
          // 刷新列表
          this.loadRecords();
        } else {
          this.$message.error('删除失败：' + res.data.msg);
        }
      }).catch(error => {
        loading.close();
        console.log(error);
        this.$message.error('删除失败');
      });
    },

    // 自动刷新
    startAutoRefresh() {
      this.refreshTimer = setInterval(() => {
        this.loadRecords();
      }, 30000); // 30秒刷新一次
    },

    stopAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  }
};
</script>

<style scoped lang="stylus">
@import "~@/assets/css/varibles.styl"

.wrapper
  padding 20px

.upload-wrap
  width 60%
  margin 20px auto
  position relative

.statistics-wrap
  flex 1
  padding 20px
  background #f9fafb
  border-radius 8px
  border 1px solid #e4e7ed

.stat-card
  text-align center
  padding 20px 10px
  background white
  border-radius 6px
  box-shadow 0 2px 4px rgba(0,0,0,0.05)
  transition all 0.3s

.stat-card:hover
  transform translateY(-2px)
  box-shadow 0 4px 8px rgba(0,0,0,0.1)

.stat-value
  font-size 32px
  font-weight bold
  margin-bottom 8px

.stat-label
  font-size 14px
  color #909399

.stat-success .stat-value
  color #67C23A

.stat-skipped .stat-value
  color #E6A23C

.stat-failed .stat-value
  color #F56C6C

.details-preview
  background white
  border-radius 4px
  padding 10px
  max-height 150px
  overflow-y auto
  border 1px solid #e4e7ed

.detail-item
  padding 8px 10px
  font-size 13px
  color #606266
  border-bottom 1px solid #f5f7fa
  line-height 1.6

.detail-item:last-child
  border-bottom none

.detail-more
  padding 8px 10px
  font-size 12px
  color #909399
  text-align center
  font-style italic

.filter-bar
  background-color #f5f7fa
  padding 15px
  border-radius 4px

.clearfix:before,
.clearfix:after
  display table
  content ""

.clearfix:after
  clear both

>>> .error-row
  background-color #fef0f0 !important

>>> .el-table__body tr.error-row:hover > td
  background-color #fde2e2 !important

>>> .el-textarea__inner
  min-height 40px !important
</style>
